module.exports = __webpack_public_path__ + "img/horizontal_6_2_8017.424ac3ed.png";